import {  Component                     ,
          Input                         } from "@angular/core";
import {  CommonModule                  } from "@angular/common";
import {  TranslatePipe                 } from "nv@services/translate.service";
import { TransfromToYearMonthLabelPipe  } from "nv@pipes/year-month-label.pipe";

@Component({
  selector    : 'template-summary',
  templateUrl : './template-summary.component.html',
  styleUrl    : './template-summary.component.scss',
  imports: [
    CommonModule,
    TranslatePipe,
    TransfromToYearMonthLabelPipe
]
})
export class TemplateSummary {

  @Input() public inputData!: any;
}
